export default __webpack_public_path__ + "static/media/Resource-Icons-3to4-text-transparent.be358b1c.png";